'use strict';

var Collection = require('base/Colido.Collection');
var ScannerModel = require('../models/scanner');

/**
 * Collection for the rfid scanners
 *
 * @category   Collection
 * @module     global
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */
var ScannersCollection = Collection.extend({
    api: '/scanners',

    name: 'collection:scanners',

    model: ScannerModel,

    initialize: function(models, options) {
        this.listenTo(App.radio(this.name).vent, 'updated', function(data) {
            this.setFromWebsocket(data, {remove: false});
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'removed', function(data) {
            this.remove(data); //data [1,2,3]
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'added', function(data) {
            this.add(data);
        }.bind(this));
    },
});

module.exports = ScannersCollection;